import ym from 'react-yandex-metrika';
import { ProductTour } from '@edu-frontend/modules/src/features/productTour';

export type ProductTourFunctionParams = {
    tour: ProductTour;
    step?: Partial<ProductTour['steps'][number]>;
};

export const getMetrilaCallbacks = ({ next }: { next: () => void }) => {
    const onStartTour = (params: ProductTourFunctionParams) => {
        ym('reachGoal', 'teacher_producttour_start', { id: params.tour.id, header: params.tour.header });
        next();
    };

    const onCloseModalTour = (params: ProductTourFunctionParams) => {
        ym('reachGoal', 'teacher_producttour_preview_closed', { id: params.tour.id, header: params.tour.header });
    };

    const onCloseTooltipTour = (params: ProductTourFunctionParams) => {
        ym('reachGoal', 'teacher_producttour_closed', {
            id: params.tour.id,
            header: params.tour.header,
            idStep: params.step?.id,
            headerStep: params.step?.header,
        });
    };

    const onNextStep = (params: ProductTourFunctionParams) => {
        ym('reachGoal', 'teacher_producttour_next_clicked', {
            id: params.tour.id,
            header: params.tour.header,
            idStep: params.step?.id,
            headerStep: params.step?.header,
        });
    };

    const onBackStep = (params: ProductTourFunctionParams) => {
        ym('reachGoal', 'teacher_producttour_back_clicked', {
            id: params.tour.id,
            header: params.tour.header,
            idStep: params.step?.id,
            headerStep: params.step?.header,
        });
    };

    return {
        onStartTour,
        onCloseModalTour,
        onCloseTooltipTour,
        onNextStep,
        onBackStep,
    };
};
